export const CU_CATEGORIES = [
  "2b8771e1-d19f-11ea-b593-0242ab23801e",
  "4af58208-d19f-11ea-b593-0242ab23801e",
  "4bd873fb-4ee6-4822-9c72-695dfca2312b",
  "6616faec-82c2-46fd-91e0-dc40d14cff0f",
];

export const CU_ROW_TYPES = {
  IMPORTO: "importo",
  INTERO: "intero",
  DATA: "data",
  TEXT: "testo",
  ANNO: "anno",
  CF: "CF",
  TEXTAREA: "area di testo",
  OPTIONS: "opzioni",
};

export const CU_GROUPS = {
  DICHIARAZIONE: "dichiarazione",
  ANAGRAFICA: "anagrafica",
  REDDITI: "redditi",
  RITENUTE: "ritenute",
  CREDITI_NON_RIMBORSATI: "crediti non rimborsati dichiarante",
  ACCONTI_DICH: "acconti {YEAR} Dichiarante",
  CREDITI_NON_RIMBORSATI_2: "crediti non rimborsati coniuge",
  BONUS: "trattamento integrativo",
  ACCONTI_CON: "acconti {YEAR} coniuge",
  CONTRIBUTI_PRIMA_OCC: "previdenza complementare",
  CONTRIBUTI_FAM: "contributi previdenza complementare per familiari a carico",
  SOMME_EROG: "somme erogate per premi di risultato",
  DATORE_LAVORO: "datore Lavoro",
  LAVORO_AUTONOMO: "lavoro autonomo - Quadro D - 730",
  LOC_BREVI: "locazioni brevi",
  EDILE: "cassa Edile",
  DET_CREDITI: "detrazioni e crediti",
  ONERI_DETRAIBILI: "oneri detraibili",
  ALTRI_DATI: "altri Dati",
  COMPENSO_CAMPIONE: "compenso lordo Campione D'Italia",
  REDDITI_NETTO_CAMPIONE:
    "redditi dei punti da 1 al 5 al netto dei compensi di Campione D'Italia",
};

export const CU_ROWS = [
  {
    key: "annoRiferimento",
    label: "Anno Fiscale",
    type: CU_ROW_TYPES.DATA,
    group: CU_GROUPS.DICHIARAZIONE,
    required: true,
  },
  {
    key: "datLavNome",
    label: "Nome",
    type: CU_ROW_TYPES.TEXT,
    group: CU_GROUPS.DATORE_LAVORO,
    full: true,
  },
  {
    key: "datLavCognome",
    label: "Cognome",
    type: CU_ROW_TYPES.TEXT,
    group: CU_GROUPS.DATORE_LAVORO,
    full: true,
  },
  {
    key: "datLavCodiceFiscale",
    label: "Codice Fiscale",
    type: CU_ROW_TYPES.TEXT,
    group: CU_GROUPS.DATORE_LAVORO,
    full: true,
  },
  {
    key: "nome",
    label: "Nome",
    type: CU_ROW_TYPES.TEXT,
    group: CU_GROUPS.ANAGRAFICA,
    full: true,
    required: true,
  },
  {
    key: "cognome",
    label: "Cognome",
    type: CU_ROW_TYPES.TEXT,
    group: CU_GROUPS.ANAGRAFICA,
    full: true,
    required: true,
  },
  {
    key: "codiceFiscale",
    label: "Codice Fiscale",
    type: CU_ROW_TYPES.CF,
    group: CU_GROUPS.ANAGRAFICA,
    full: true,
    required: true,
  },
  {
    key: "field1",
    label: "Punto 1",
    type: CU_ROW_TYPES.IMPORTO,
    group: CU_GROUPS.REDDITI,
    desc: "Tempo indeterminato",
  },
  {
    key: "field2",
    label: "Punto 2",
    type: CU_ROW_TYPES.IMPORTO,
    group: CU_GROUPS.REDDITI,
    desc: "Tempo determinato",
  },
  {
    key: "field3",
    label: "Punto 3",
    type: CU_ROW_TYPES.IMPORTO,
    group: CU_GROUPS.REDDITI,
    desc: "Redditi Pensione",
  },
  {
    key: "field4",
    label: "Punto 4",
    type: CU_ROW_TYPES.IMPORTO,
    group: CU_GROUPS.REDDITI,
    desc: "Altri redditi assimilati",
  },
  {
    key: "field5",
    label: "Punto 5",
    type: CU_ROW_TYPES.IMPORTO,
    group: CU_GROUPS.REDDITI,
    desc: "Assegni Coniuge",
  },
  {
    key: "field6",
    label: "Punto 6",
    type: CU_ROW_TYPES.INTERO,
    group: CU_GROUPS.REDDITI,
    desc: "Numero di giorni per i quali spettano le detrazioni Lavoro Dipendente",
  },
  {
    key: "field7",
    label: "Punto 7",
    type: CU_ROW_TYPES.INTERO,
    group: CU_GROUPS.REDDITI,
    desc: "Numero di giorni per i quali spettano le detrazioni Pensione",
  },
  {
    key: "field12",
    label: "Punto 12",
    type: CU_ROW_TYPES.IMPORTO,
    group: CU_GROUPS.REDDITI,
    desc: "Redditi erogati in franchi",
  },
  // {
  //   key: 'field13',
  //   label: 'Punto 13',
  //   type: CU_ROW_TYPES.INTERO,
  //   group: CU_GROUPS.REDDITI,
  //   desc: 'Giorni primo semestre',
  // },
  // {
  //   key: 'field14',
  //   label: 'Punto 14',
  //   type: CU_ROW_TYPES.INTERO,
  //   group: CU_GROUPS.REDDITI,
  //   desc: 'Giorni secondo semestre',
  // },
  {
    key: "field21",
    label: "Punto 21",
    type: CU_ROW_TYPES.IMPORTO,
    group: CU_GROUPS.RITENUTE,
    desc: "Ritenute IRPEF",
  },
  {
    key: "field22",
    label: "Punto 22",
    type: CU_ROW_TYPES.IMPORTO,
    group: CU_GROUPS.RITENUTE,
    desc: "Add. Regionale",
  },
  {
    key: "field26",
    label: "Punto 26",
    type: CU_ROW_TYPES.IMPORTO,
    group: CU_GROUPS.RITENUTE,
    desc: "ADDIZIONALE COMUNALE ALL’IRPEF Acconto {YEAR}",
  },
  {
    key: "field27",
    label: "Punto 27",
    type: CU_ROW_TYPES.IMPORTO,
    group: CU_GROUPS.RITENUTE,
    desc: "ADDIZIONALE COMUNALE ALL’IRPEF Saldo {YEAR}",
  },
  {
    key: "field29",
    label: "Punto 29",
    type: CU_ROW_TYPES.IMPORTO,
    group: CU_GROUPS.RITENUTE,
    desc: "ADDIZIONALE COMUNALE ALL’IRPEF Acconto {YEAR_NEXT}",
  },
  {
    key: "field30",
    label: "Punto 30",
    type: CU_ROW_TYPES.IMPORTO,
    group: CU_GROUPS.RITENUTE,
    desc: "",
  },
  {
    key: "field31",
    label: "Punto 31",
    type: CU_ROW_TYPES.IMPORTO,
    group: CU_GROUPS.RITENUTE,
    desc: "",
  },
  {
    key: "field33",
    label: "Punto 33",
    type: CU_ROW_TYPES.IMPORTO,
    group: CU_GROUPS.RITENUTE,
    desc: "",
  },
  {
    key: "field34",
    label: "Punto 34",
    type: CU_ROW_TYPES.IMPORTO,
    group: CU_GROUPS.RITENUTE,
    desc: "",
  },
  {
    key: "field64",
    label: "Punto 64",
    type: CU_ROW_TYPES.IMPORTO,
    group: CU_GROUPS.CREDITI_NON_RIMBORSATI,
    desc: "Credito Irpef non rimborsato",
  },
  {
    key: "field74",
    label: "Punto 74",
    type: CU_ROW_TYPES.IMPORTO,
    group: CU_GROUPS.CREDITI_NON_RIMBORSATI,
    desc: "Credito Add. Regionale Irpef non rimborsato",
  },
  {
    key: "field84",
    label: "Punto 84",
    type: CU_ROW_TYPES.IMPORTO,
    group: CU_GROUPS.CREDITI_NON_RIMBORSATI,
    desc: "Credito Add. Comunale Irpef non rimborsato",
  },
  {
    key: "field94",
    label: "Punto 94",
    type: CU_ROW_TYPES.IMPORTO,
    group: CU_GROUPS.CREDITI_NON_RIMBORSATI,
    desc: "Credito cedolare secca non rimborsato",
  },
  {
    key: "field121",
    label: "Punto 121",
    type: CU_ROW_TYPES.IMPORTO,
    group: CU_GROUPS.ACCONTI_DICH,
    desc: "Primo acconto Irpef trattenuto nell’anno",
  },
  {
    key: "field122",
    label: "Punto 122",
    type: CU_ROW_TYPES.IMPORTO,
    group: CU_GROUPS.ACCONTI_DICH,
    desc: "Secondo/unico acc. Irpef tratt. nell’anno",
  },
  {
    key: "field124",
    label: "Punto 124",
    type: CU_ROW_TYPES.IMPORTO,
    group: CU_GROUPS.ACCONTI_DICH,
    desc: "Acconto all’addizionale comunale all’Irpef",
  },
  {
    key: "field126",
    label: "Punto 126",
    type: CU_ROW_TYPES.IMPORTO,
    group: CU_GROUPS.ACCONTI_DICH,
    desc: "Prima rata di acconto cedolare secca",
  },
  {
    key: "field127",
    label: "Punto 127",
    type: CU_ROW_TYPES.IMPORTO,
    group: CU_GROUPS.ACCONTI_DICH,
    desc: "Seconda/unica rata di acconto cedol. secca",
  },
  {
    key: "field131",
    label: "Punto 131",
    type: CU_ROW_TYPES.IMPORTO,
    group: CU_GROUPS.ACCONTI_DICH,
    desc: "",
  },
  {
    key: "field132",
    label: "Punto 132",
    type: CU_ROW_TYPES.IMPORTO,
    group: CU_GROUPS.ACCONTI_DICH,
    desc: "",
  },
  {
    key: "field133",
    label: "Punto 133",
    type: CU_ROW_TYPES.IMPORTO,
    group: CU_GROUPS.ACCONTI_DICH,
    desc: "",
  },
  {
    key: "field264",
    label: "Punto 264",
    type: CU_ROW_TYPES.IMPORTO,
    group: CU_GROUPS.CREDITI_NON_RIMBORSATI_2,
    desc: "Credito Irpef non rimborsato",
  },
  {
    key: "field274",
    label: "Punto 274",
    type: CU_ROW_TYPES.IMPORTO,
    group: CU_GROUPS.CREDITI_NON_RIMBORSATI_2,
    desc: "Credito Add. Regionale Irpef non rimborsato",
  },
  {
    key: "field284",
    label: "Punto 284",
    type: CU_ROW_TYPES.IMPORTO,
    group: CU_GROUPS.CREDITI_NON_RIMBORSATI_2,
    desc: "Credito Add. Comunale Irpef non rimborsato",
  },
  {
    key: "field294",
    label: "Punto 294",
    type: CU_ROW_TYPES.IMPORTO,
    group: CU_GROUPS.CREDITI_NON_RIMBORSATI_2,
    desc: "Credito cedolare secca non rimborsato",
  },
  {
    key: "field364",
    label: "Punto 364",
    type: CU_ROW_TYPES.IMPORTO,
    group: CU_GROUPS.DET_CREDITI,
    desc: "",
  },
  {
    key: "field371",
    label: "Punto 371",
    type: CU_ROW_TYPES.IMPORTO,
    group: CU_GROUPS.DET_CREDITI,
    desc: "",
  },
  {
    key: "field374",
    label: "Punto 374",
    type: CU_ROW_TYPES.IMPORTO,
    group: CU_GROUPS.DET_CREDITI,
    desc: "Totale detrazioni",
  },
  {
    key: "field381",
    label: "Punto 381",
    type: CU_ROW_TYPES.IMPORTO,
    group: CU_GROUPS.DET_CREDITI,
    desc: "",
  },
  {
    key: "field384",
    label: "Punto 384",
    type: CU_ROW_TYPES.IMPORTO,
    group: CU_GROUPS.DET_CREDITI,
    desc: "",
  },
  {
    key: "field385",
    label: "Punto 385",
    type: CU_ROW_TYPES.IMPORTO,
    group: CU_GROUPS.DET_CREDITI,
    desc: "",
  },
  {
    key: "field516",
    label: "Punto 516",
    type: CU_ROW_TYPES.IMPORTO,
    group: CU_GROUPS.DET_CREDITI,
    desc: "",
  },
  {
    key: "field390",
    label: "Punto 390",
    type: CU_ROW_TYPES.OPTIONS,
    group: CU_GROUPS.BONUS,
    desc: "Codice trattamento",
    options: ["non selezionato", "1", "2"],
  },
  {
    key: "field391_2022",
    label: "Punto 391",
    type: CU_ROW_TYPES.IMPORTO,
    group: CU_GROUPS.BONUS,
    desc: "Trattamento erogato",
  },
  {
    key: "field321",
    label: "Punto 321",
    type: CU_ROW_TYPES.IMPORTO,
    group: CU_GROUPS.ACCONTI_CON,
    desc: "Primo acconto Irpef trattenuto nell’anno",
  },
  {
    key: "field322",
    label: "Punto 322",
    type: CU_ROW_TYPES.IMPORTO,
    group: CU_GROUPS.ACCONTI_CON,
    desc: "Secondo/unico acc. Irpef tratt. nell’anno",
  },
  {
    key: "field324",
    label: "Punto 324",
    type: CU_ROW_TYPES.IMPORTO,
    group: CU_GROUPS.ACCONTI_CON,
    desc: "Acconto all’addizionale comunale all’Irpef",
  },
  {
    key: "field326",
    label: "Punto 326",
    type: CU_ROW_TYPES.IMPORTO,
    group: CU_GROUPS.ACCONTI_CON,
    desc: "Prima rata di acconto cedolare secca",
  },
  {
    key: "field327",
    label: "Punto 327",
    type: CU_ROW_TYPES.IMPORTO,
    group: CU_GROUPS.ACCONTI_CON,
    desc: "Seconda/unica rata di acconto cedol. secca",
  },
  {
    key: "field331",
    label: "Punto 331",
    type: CU_ROW_TYPES.IMPORTO,
    group: CU_GROUPS.ACCONTI_CON,
    desc: "",
  },
  {
    key: "field332",
    label: "Punto 332",
    type: CU_ROW_TYPES.IMPORTO,
    group: CU_GROUPS.ACCONTI_CON,
    desc: "",
  },
  {
    key: "field333",
    label: "Punto 333",
    type: CU_ROW_TYPES.IMPORTO,
    group: CU_GROUPS.ACCONTI_CON,
    desc: "",
  },
  {
    key: "field341",
    label: "Punto 341",
    type: CU_ROW_TYPES.INTERO,
    group: CU_GROUPS.ONERI_DETRAIBILI,
    desc: "",
  },
  {
    key: "field342",
    label: "Punto 342",
    type: CU_ROW_TYPES.IMPORTO,
    group: CU_GROUPS.ONERI_DETRAIBILI,
    desc: "",
  },
  {
    key: "field343",
    label: "Punto 343",
    type: CU_ROW_TYPES.INTERO,
    group: CU_GROUPS.ONERI_DETRAIBILI,
    desc: "",
  },
  {
    key: "field344",
    label: "Punto 344",
    type: CU_ROW_TYPES.IMPORTO,
    group: CU_GROUPS.ONERI_DETRAIBILI,
    desc: "",
  },
  {
    key: "field345",
    label: "Punto 345",
    type: CU_ROW_TYPES.INTERO,
    group: CU_GROUPS.ONERI_DETRAIBILI,
    desc: "",
  },
  {
    key: "field346",
    label: "Punto 346",
    type: CU_ROW_TYPES.IMPORTO,
    group: CU_GROUPS.ONERI_DETRAIBILI,
    desc: "",
  },
  {
    key: "field347",
    label: "Punto 347",
    type: CU_ROW_TYPES.INTERO,
    group: CU_GROUPS.ONERI_DETRAIBILI,
    desc: "",
  },
  {
    key: "field348",
    label: "Punto 348",
    type: CU_ROW_TYPES.IMPORTO,
    group: CU_GROUPS.ONERI_DETRAIBILI,
    desc: "",
  },
  // {
  //   key: 'field400',
  //   label: 'Punto 400',
  //   type: CU_ROW_TYPES.INTERO,
  //   group: CU_GROUPS.CONTRIBUTI_PRIMA_OCC,
  //   desc: 'Codice trattamento',
  // },
  // {
  //   key: 'field401',
  //   label: 'Punto 401',
  //   type: CU_ROW_TYPES.IMPORTO,
  //   group: CU_GROUPS.CONTRIBUTI_PRIMA_OCC,
  //   desc: 'Trattamento erogato',
  // },
  // {
  //   key: 'field402',
  //   label: 'Punto 402',
  //   type: CU_ROW_TYPES.IMPORTO,
  //   group: CU_GROUPS.CONTRIBUTI_PRIMA_OCC,
  //   desc: 'Trattamento NON erogato',
  // },
  {
    key: "field411",
    label: "Punto 411",
    type: CU_ROW_TYPES.INTERO,
    group: CU_GROUPS.CONTRIBUTI_PRIMA_OCC,
    desc: "Previdenza complementare",
  },
  {
    key: "field412",
    label: "Punto 412",
    type: CU_ROW_TYPES.IMPORTO,
    group: CU_GROUPS.CONTRIBUTI_PRIMA_OCC,
    desc: "Contrib. dedotti redditi pt. 1,2,3,4,5",
  },
  {
    key: "field413",
    label: "Punto 413",
    type: CU_ROW_TYPES.IMPORTO,
    group: CU_GROUPS.CONTRIBUTI_PRIMA_OCC,
    desc: "Contrib. non dedotti redditi pt. 1,2,3,4,5",
  },
  {
    key: "field417",
    label: "Punto 417",
    type: CU_ROW_TYPES.IMPORTO,
    group: CU_GROUPS.CONTRIBUTI_PRIMA_OCC,
    desc: "CONTRIBUTI LAV. PRIMA OCCUPAZIONE Importi ecc.esclusi dai redditi pt. 1,2,3,4,5",
  },
  {
    key: "field421",
    label: "Punto 421",
    type: CU_ROW_TYPES.IMPORTO,
    group: CU_GROUPS.CONTRIBUTI_FAM,
    desc: "CONTRIBUTI PER FAMILIARI A CARICO Versati",
  },
  {
    key: "field422",
    label: "Punto 422",
    type: CU_ROW_TYPES.IMPORTO,
    group: CU_GROUPS.CONTRIBUTI_FAM,
    desc: "CONTRIBUTI PER FAMILIARI A CARICO Dedotti",
  },
  {
    key: "field423",
    label: "Punto 423",
    type: CU_ROW_TYPES.IMPORTO,
    group: CU_GROUPS.CONTRIBUTI_FAM,
    desc: "CONTRIBUTI PER FAMILIARI A CARICO Non dedotti",
  },
  {
    key: "field571",
    label: "Punto 571",
    type: CU_ROW_TYPES.INTERO,
    group: CU_GROUPS.SOMME_EROG,
    desc: "Codice",
  },
  {
    key: "field572",
    label: "Punto 572",
    type: CU_ROW_TYPES.IMPORTO,
    group: CU_GROUPS.SOMME_EROG,
    desc: "Premi risultato imposta sostitutiva",
  },
  {
    key: "field573",
    label: "Punto 573",
    type: CU_ROW_TYPES.IMPORTO,
    group: CU_GROUPS.SOMME_EROG,
    desc: "Benefit",
  },
  {
    key: "field576",
    label: "Punto 576",
    type: CU_ROW_TYPES.IMPORTO,
    group: CU_GROUPS.SOMME_EROG,
    desc: "Imposta sostitutiva",
  },
  {
    key: "field577",
    label: "Punto 577",
    type: CU_ROW_TYPES.IMPORTO,
    group: CU_GROUPS.SOMME_EROG,
    desc: "",
  },
  {
    key: "field578",
    label: "Punto 578",
    type: CU_ROW_TYPES.IMPORTO,
    group: CU_GROUPS.SOMME_EROG,
    desc: "Premi risultato tassazione ordinaria",
  },
  {
    key: "field579",
    label: "Punto 579",
    type: CU_ROW_TYPES.IMPORTO,
    group: CU_GROUPS.SOMME_EROG,
    desc: "Benefit tass. ord.",
  },
  {
    key: "field591",
    label: "Punto 591",
    type: CU_ROW_TYPES.INTERO,
    group: CU_GROUPS.SOMME_EROG,
    desc: "Codice",
  },
  {
    key: "field592",
    label: "Punto 592",
    type: CU_ROW_TYPES.IMPORTO,
    group: CU_GROUPS.SOMME_EROG,
    desc: "Premi risultato imposta sostitutiva",
  },
  {
    key: "field593",
    label: "Punto 593",
    type: CU_ROW_TYPES.IMPORTO,
    group: CU_GROUPS.SOMME_EROG,
    desc: "Benefit",
  },
  {
    key: "field596",
    label: "Punto 596",
    type: CU_ROW_TYPES.IMPORTO,
    group: CU_GROUPS.SOMME_EROG,
    desc: "Imposta sostitutiva",
  },
  {
    key: "field597",
    label: "Punto 597",
    type: CU_ROW_TYPES.IMPORTO,
    group: CU_GROUPS.SOMME_EROG,
    desc: "",
  },
  {
    key: "field598",
    label: "Punto 598",
    type: CU_ROW_TYPES.IMPORTO,
    group: CU_GROUPS.SOMME_EROG,
    desc: "Premi risultato tassazione ordinaria",
  },
  {
    key: "field599",
    label: "Punto 599",
    type: CU_ROW_TYPES.IMPORTO,
    group: CU_GROUPS.SOMME_EROG,
    desc: "Benefit tass. ord.",
  },
  {
    key: "LACausale",
    label: "Causale",
    type: CU_ROW_TYPES.OPTIONS,
    group: CU_GROUPS.LAVORO_AUTONOMO,
    desc: "",
    full: true,
    options: [
      "0 - NULL",
      "B – utilizzazione economica di opere dell’ingegno",
      "C – utili da contratti di assoc. in partecip. apporto solo da prestazione di lavoro",
      "D – utili spettanti ai soci promotori ed ai soci fondatori delle società di capitali",
      "E – levata di protesti cambiari da parte dei segretari comunali",
      "F – indennità corrisposte ai giudici onorari di pace e ai vice procuratori onorari",
      "L – redditi per diritti acquisiti di opere dell’ingegno formule a titolo gratuito",
      "L1 – redditi per diritti acquisiti di opere dell’ingegno a titolo oneroso",
      "M – prestazioni di lavoro autonomo non esercitate abitualmente",
      "M1 – redditi derivanti dall’assunzione di obblighi di fare, di non fare o permettere",
      "M2 – prestazioni di lavoro autonomo non esercitate abitualmente (obbligo iscr. ENPAPI)",
      "N – indennità di trasferta, rimborso forfetario att. sportive dilettantistiche",
      "O – prestazioni di lavoro autonomo non esercitate abitualmente (no obbligo iscr. ENPAPI)",
      "O1 – redditi derivanti dall’assunzione di obblighi di fare, di non fare o permettere (no obbligo iscr. ENPAPI)",
      "V1 – redditi derivanti da attività commerciali non esercitate abitualmente",
    ],
  },
  {
    key: "lAfield4",
    label: "Punto 4",
    type: CU_ROW_TYPES.IMPORTO,
    group: CU_GROUPS.LAVORO_AUTONOMO,
    desc: "ammontare lordo corrisposto",
  },
  {
    key: "lAfield7",
    label: "Punto 7",
    type: CU_ROW_TYPES.IMPORTO,
    group: CU_GROUPS.LAVORO_AUTONOMO,
    desc: "altre somme non soggette a ritenuta",
  },
  {
    key: "lAfield8",
    label: "Punto 8",
    type: CU_ROW_TYPES.IMPORTO,
    group: CU_GROUPS.LAVORO_AUTONOMO,
    desc: "imponibile",
  },
  {
    key: "lAfield9",
    label: "Punto 9",
    type: CU_ROW_TYPES.IMPORTO,
    group: CU_GROUPS.LAVORO_AUTONOMO,
    desc: "ritenute a titolo d’acconto",
  },
  {
    key: "lAfield10",
    label: "Punto 10",
    type: CU_ROW_TYPES.IMPORTO,
    group: CU_GROUPS.LAVORO_AUTONOMO,
    desc: "ritenute a titolo d’imposta",
  },
  {
    key: "lAfield11",
    label: "Punto 11",
    type: CU_ROW_TYPES.IMPORTO,
    group: CU_GROUPS.LAVORO_AUTONOMO,
    desc: "ritenute sospese",
  },
  {
    key: "lAfield12",
    label: "Punto 12",
    type: CU_ROW_TYPES.IMPORTO,
    group: CU_GROUPS.LAVORO_AUTONOMO,
    desc: "addizionale regionale a titolo d’acconto",
  },
  {
    key: "lAfield13",
    label: "Punto 13",
    type: CU_ROW_TYPES.IMPORTO,
    group: CU_GROUPS.LAVORO_AUTONOMO,
    desc: "addizionale regionale a titolo d’imposta",
  },
  {
    key: "lAfield14",
    label: "Punto 14",
    type: CU_ROW_TYPES.IMPORTO,
    group: CU_GROUPS.LAVORO_AUTONOMO,
    desc: "addizionale regionale sospesa",
  },
  {
    key: "lAfield15",
    label: "Punto 15",
    type: CU_ROW_TYPES.IMPORTO,
    group: CU_GROUPS.LAVORO_AUTONOMO,
    desc: "addizionale comunalea titolo d’acconto",
  },
  {
    key: "lAfield16",
    label: "Punto 16",
    type: CU_ROW_TYPES.IMPORTO,
    group: CU_GROUPS.LAVORO_AUTONOMO,
    desc: "addizionale comunale a titolo d’imposta",
  },
  {
    key: "lAfield17",
    label: "Punto 17",
    type: CU_ROW_TYPES.IMPORTO,
    group: CU_GROUPS.LAVORO_AUTONOMO,
    desc: "addizionale comunale sospesa",
  },
  {
    key: "lAfield35",
    label: "Punto 35",
    type: CU_ROW_TYPES.IMPORTO,
    group: CU_GROUPS.LAVORO_AUTONOMO,
    desc: "contributi previdenziali a carico del percipiente",
  },
  // LOCAZIONI BREVI
  {
    key: "LBfield4",
    label: "Punto 4",
    type: CU_ROW_TYPES.DATA,
    group: CU_GROUPS.LOC_BREVI,
    desc: "anno",
  },
  {
    key: "LBfield5",
    label: "Punto 5",
    type: CU_ROW_TYPES.INTERO,
    group: CU_GROUPS.LOC_BREVI,
    desc: "durata del contratto nell’anno di riferimento",
  },
  {
    key: "LBfield14",
    label: "Punto 14",
    type: CU_ROW_TYPES.IMPORTO,
    group: CU_GROUPS.LOC_BREVI,
    desc: "importo corrispettivo",
  },
  {
    key: "LBfield15",
    label: "Punto 15",
    type: CU_ROW_TYPES.IMPORTO,
    group: CU_GROUPS.LOC_BREVI,
    desc: "ritenuta operata",
  },
  {
    key: "LBfield16",
    label: "Punto 16",
    type: CU_ROW_TYPES.BOOL,
    group: CU_GROUPS.LOC_BREVI,
    desc: "locatore non proprietario",
  },
  {
    key: "LBCedSecca",
    label: "Cedolare Secca",
    type: CU_ROW_TYPES.BOOL,
    group: CU_GROUPS.LOC_BREVI,
    desc: "",
  },
  {
    key: "LBfield104",
    label: "Punto 104",
    type: CU_ROW_TYPES.DATA,
    group: CU_GROUPS.LOC_BREVI,
    desc: "anno",
  },
  {
    key: "LBfield105",
    label: "Punto 105",
    type: CU_ROW_TYPES.INTERO,
    group: CU_GROUPS.LOC_BREVI,
    desc: "durata del contratto nell’anno di riferimento",
  },
  {
    key: "LBfield114",
    label: "Punto 114",
    type: CU_ROW_TYPES.IMPORTO,
    group: CU_GROUPS.LOC_BREVI,
    desc: "importo corrispettivo ",
  },
  {
    key: "LBfield115",
    label: "Punto 115",
    type: CU_ROW_TYPES.IMPORTO,
    group: CU_GROUPS.LOC_BREVI,
    desc: "ritenuta operata",
  },
  {
    key: "LBfield116",
    label: "Punto 116",
    type: CU_ROW_TYPES.BOOL,
    group: CU_GROUPS.LOC_BREVI,
    desc: "locatore non proprietario",
  },
  {
    key: "LBCedSecca1",
    label: "Cedolare Secca 1",
    type: CU_ROW_TYPES.BOOL,
    group: CU_GROUPS.LOC_BREVI,
    desc: "",
  },

  {
    key: "LBfield204",
    label: "Punto 204",
    type: CU_ROW_TYPES.DATA,
    group: CU_GROUPS.LOC_BREVI,
    desc: "anno",
  },
  {
    key: "LBfield205",
    label: "Punto 205",
    type: CU_ROW_TYPES.INTERO,
    group: CU_GROUPS.LOC_BREVI,
    desc: "durata del contratto nell’anno di riferimento",
  },
  {
    key: "LBfield214",
    label: "Punto 214",
    type: CU_ROW_TYPES.IMPORTO,
    group: CU_GROUPS.LOC_BREVI,
    desc: "importo corrispettivo",
  },
  {
    key: "LBfield215",
    label: "Punto 215",
    type: CU_ROW_TYPES.IMPORTO,
    group: CU_GROUPS.LOC_BREVI,
    desc: "ritenuta operata",
  },
  {
    key: "LBfield216",
    label: "Punto 216",
    type: CU_ROW_TYPES.BOOL,
    group: CU_GROUPS.LOC_BREVI,
    desc: "locatore non proprietario",
  },
  {
    key: "LBCedSecca2",
    label: "Cedolare Secca 2",
    type: CU_ROW_TYPES.BOOL,
    group: CU_GROUPS.LOC_BREVI,
    desc: "",
  },

  {
    key: "LBfield304",
    label: "Punto 304",
    type: CU_ROW_TYPES.DATA,
    group: CU_GROUPS.LOC_BREVI,
    desc: "anno",
  },
  {
    key: "LBfield305",
    label: "Punto 305",
    type: CU_ROW_TYPES.INTERO,
    group: CU_GROUPS.LOC_BREVI,
    desc: "durata del contratto nell’anno di riferimento",
  },
  {
    key: "LBfield314",
    label: "Punto 314",
    type: CU_ROW_TYPES.IMPORTO,
    group: CU_GROUPS.LOC_BREVI,
    desc: "importo corrispettivo",
  },
  {
    key: "LBfield315",
    label: "Punto 315",
    type: CU_ROW_TYPES.IMPORTO,
    group: CU_GROUPS.LOC_BREVI,
    desc: "ritenuta operata",
  },
  {
    key: "LBfield316",
    label: "Punto 316",
    type: CU_ROW_TYPES.BOOL,
    group: CU_GROUPS.LOC_BREVI,
    desc: "locatore non proprietario",
  },
  {
    key: "LBCedSecca3",
    label: "Cedolare Secca 3",
    type: CU_ROW_TYPES.BOOL,
    group: CU_GROUPS.LOC_BREVI,
    desc: "",
  },
  {
    key: "LBfield404",
    label: "Punto 404",
    type: CU_ROW_TYPES.DATA,
    group: CU_GROUPS.LOC_BREVI,
    desc: "anno",
  },
  {
    key: "LBfield405",
    label: "Punto 405",
    type: CU_ROW_TYPES.INTERO,
    group: CU_GROUPS.LOC_BREVI,
    desc: "durata del contratto nell’anno di riferimento",
  },
  {
    key: "LBfield414",
    label: "Punto 414",
    type: CU_ROW_TYPES.IMPORTO,
    group: CU_GROUPS.LOC_BREVI,
    desc: "importo corrispettivo",
  },
  {
    key: "LBfield415",
    label: "Punto 415",
    type: CU_ROW_TYPES.IMPORTO,
    group: CU_GROUPS.LOC_BREVI,
    desc: "ritenuta operata",
  },
  {
    key: "LBfield416",
    label: "Punto 416",
    type: CU_ROW_TYPES.BOOL,
    group: CU_GROUPS.LOC_BREVI,
    desc: "locatore non proprietario",
  },
  {
    key: "LBCedSecca4",
    label: "Cedolare Secca 4",
    type: CU_ROW_TYPES.BOOL,
    group: CU_GROUPS.LOC_BREVI,
    desc: "",
  },
  {
    key: "field455",
    label: "Punto 455",
    type: CU_ROW_TYPES.IMPORTO,
    group: CU_GROUPS.ALTRI_DATI,
    desc: "",
  },
  {
    key: "field456",
    label: "Punto 456",
    type: CU_ROW_TYPES.IMPORTO,
    group: CU_GROUPS.ALTRI_DATI,
    desc: "",
  },
  {
    key: "field457",
    label: "Punto 457",
    type: CU_ROW_TYPES.IMPORTO,
    group: CU_GROUPS.ALTRI_DATI,
    desc: "",
  },
  {
    key: "field462",
    label: "Punto 462",
    type: CU_ROW_TYPES.INTERO,
    group: CU_GROUPS.ALTRI_DATI,
    desc: "",
  },
  {
    key: "field463",
    label: "Punto 463",
    type: CU_ROW_TYPES.IMPORTO,
    group: CU_GROUPS.ALTRI_DATI,
    desc: "",
  },
  {
    key: "field761",
    label: "Punto 761",
    type: CU_ROW_TYPES.IMPORTO,
    group: CU_GROUPS.COMPENSO_CAMPIONE,
    desc: "",
  },
  {
    key: "field762",
    label: "Punto 762",
    type: CU_ROW_TYPES.IMPORTO,
    group: CU_GROUPS.COMPENSO_CAMPIONE,
    desc: "",
  },
  {
    key: "field763",
    label: "Punto 763",
    type: CU_ROW_TYPES.IMPORTO,
    group: CU_GROUPS.COMPENSO_CAMPIONE,
    desc: "",
  },
  {
    key: "field764",
    label: "Punto 764",
    type: CU_ROW_TYPES.IMPORTO,
    group: CU_GROUPS.COMPENSO_CAMPIONE,
    desc: "",
  },
  {
    key: "field765",
    label: "Punto 765",
    type: CU_ROW_TYPES.IMPORTO,
    group: CU_GROUPS.COMPENSO_CAMPIONE,
    desc: "",
  },
  {
    key: "field766",
    label: "Punto 766",
    type: CU_ROW_TYPES.IMPORTO,
    group: CU_GROUPS.COMPENSO_CAMPIONE,
    desc: "",
  },
  {
    key: "field771",
    label: "Punto 771",
    type: CU_ROW_TYPES.IMPORTO,
    group: CU_GROUPS.REDDITI_NETTO_CAMPIONE,
    desc: "",
  },
  {
    key: "field772",
    label: "Punto 772",
    type: CU_ROW_TYPES.IMPORTO,
    group: CU_GROUPS.REDDITI_NETTO_CAMPIONE,
    desc: "",
  },
  {
    key: "field773",
    label: "Punto 773",
    type: CU_ROW_TYPES.IMPORTO,
    group: CU_GROUPS.REDDITI_NETTO_CAMPIONE,
    desc: "",
  },
  {
    key: "field774",
    label: "Punto 774",
    type: CU_ROW_TYPES.IMPORTO,
    group: CU_GROUPS.REDDITI_NETTO_CAMPIONE,
    desc: "",
  },
  {
    key: "field775",
    label: "Punto 775",
    type: CU_ROW_TYPES.IMPORTO,
    group: CU_GROUPS.REDDITI_NETTO_CAMPIONE,
    desc: "",
  },
];

export const DIPENDENTE_GROUPS_ORDER = [
  CU_GROUPS.DICHIARAZIONE,
  CU_GROUPS.DATORE_LAVORO,
  CU_GROUPS.ANAGRAFICA,
  CU_GROUPS.REDDITI,
  CU_GROUPS.RITENUTE,
  CU_GROUPS.CREDITI_NON_RIMBORSATI,
  CU_GROUPS.ACCONTI_DICH,
  CU_GROUPS.CREDITI_NON_RIMBORSATI_2,
  CU_GROUPS.ACCONTI_CON,
  CU_GROUPS.ONERI_DETRAIBILI,
  CU_GROUPS.DET_CREDITI,
  CU_GROUPS.ALTRI_DATI,
  CU_GROUPS.BONUS,
  CU_GROUPS.CONTRIBUTI_PRIMA_OCC,
  CU_GROUPS.CONTRIBUTI_FAM,
  CU_GROUPS.SOMME_EROG,
  CU_GROUPS.COMPENSO_CAMPIONE,
  CU_GROUPS.REDDITI_NETTO_CAMPIONE,
];

export const AUTONOMO_GROUPS_ORDER = [
  CU_GROUPS.DICHIARAZIONE,
  CU_GROUPS.DATORE_LAVORO,
  CU_GROUPS.ANAGRAFICA,
  CU_GROUPS.LAVORO_AUTONOMO,
];

export const LOCBREVI_GROUPS_ORDER = [
  CU_GROUPS.DICHIARAZIONE,
  CU_GROUPS.DATORE_LAVORO,
  CU_GROUPS.ANAGRAFICA,
  CU_GROUPS.LOC_BREVI,
];

export const EDILE_GROUPS_ORDER = [
  CU_GROUPS.DICHIARAZIONE,
  CU_GROUPS.DATORE_LAVORO,
  CU_GROUPS.ANAGRAFICA,
  CU_GROUPS.REDDITI,
  CU_GROUPS.RITENUTE,
  CU_GROUPS.BONUS,
];

function groupOrderToList(groupOrder, exclude = []) {
  return groupOrder.map((g) => ({
    label: g,
    rows: CU_ROWS.filter((r) => r.group === g && !exclude.includes(r.key)),
  }));
}

export const CU_MASK = {

  default: groupOrderToList(DIPENDENTE_GROUPS_ORDER),
  "08dc7415-dcce-491f-8cea-cd8b124691b7": groupOrderToList(

    DIPENDENTE_GROUPS_ORDER
  ),
  "08dc7415-dcce-4ac2-8159-e9468105c22d": groupOrderToList(
    AUTONOMO_GROUPS_ORDER
  ),
  "08dc7415-dcce-4b21-8f97-2add9b59abcb": groupOrderToList(EDILE_GROUPS_ORDER, [
    "DatLavCodiceFiscale",
    "field392",
    "field22",
    "field26",
    "field27",
    "field29",
    "field2",
    "field3",
    "field4",
    "field5",
    "field6",
    "field7",
  ]),
  "08dc7415-dcce-484b-8d42-f9d220c5d0da": groupOrderToList(
    LOCBREVI_GROUPS_ORDER
  ),
};
